import { AppBar, useLogout, useGetIdentity, usePermissions } from "react-admin";
import { Box, Button, Tabs, Tab, Typography } from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import { useLocation, useNavigate } from "react-router-dom";

export function AereAppBar() {
  const logout = useLogout();
  const { identity } = useGetIdentity();
  const { permissions } = usePermissions<string>();
  const location = useLocation();
  const navigate = useNavigate();

  const isAdmin = permissions === "admin";
  const currentTab =
    location.pathname.startsWith("/users") && isAdmin ? "/users" : "/projects";

  return (
    <AppBar
      toolbar={<Box />}
      userMenu={false}
      sx={{
        "& .RaAppBar-toolbar": {
          minHeight: 56,
          px: 2,
          display: "flex",
          alignItems: "center",
          width: "100%",
        },
        "& .RaAppBar-menuButton": { display: "none" },
      }}
    >
      <Typography
        variant="h6"
        component="span"
        sx={{
          fontWeight: 400,
          letterSpacing: "0.12em",
          color: "primary.main",
          mr: 4,
          flexShrink: 0,
        }}
      >
        ÆRE
      </Typography>

      <Tabs
        value={currentTab}
        onChange={(_e, val) => navigate(val as string)}
        textColor="inherit"
        slotProps={{ indicator: { style: { backgroundColor: "var(--mui-palette-primary-main)" } } }}
        sx={{ flexGrow: 1 }}
      >
        <Tab label="Progetti" value="/projects" />
        {isAdmin && <Tab label="Utenti" value="/users" />}
      </Tabs>

      <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexShrink: 0 }}>
        {identity?.fullName && (
          <Typography
            variant="body2"
            sx={{ color: "text.secondary", display: { xs: "none", sm: "block" } }}
          >
            {identity.fullName}
          </Typography>
        )}
        <Button
          onClick={() => logout()}
          startIcon={<LogoutIcon />}
          size="small"
          sx={{
            color: "text.primary",
            textTransform: "none",
            "&:hover": { color: "primary.main" },
          }}
        >
          Esci
        </Button>
      </Box>
    </AppBar>
  );
}
